import { useDispatch, useSelector } from 'react-redux'

import { Bonus } from '../model/bonus.model'
import { FetchBonusProps } from '../services/bonus.service'
import { fetchBonus } from '../store/bonus.reducer'
import { selectBonus, selectBonusLoading, selectBonusError } from '../store/bonus.selectors'

import { StoreError } from '~/common/model'

interface useBonus {
  getBonus: (fetchBonusProps: FetchBonusProps) => unknown
  bonus?: Bonus[]
  loading: boolean
  error?: StoreError
}

export default function useBonus(subscriptionId: string): useBonus {
  const dispatch = useDispatch()

  return {
    getBonus: (fetchBonusProps: FetchBonusProps) => dispatch(fetchBonus(fetchBonusProps)),
    bonus: useSelector(selectBonus(subscriptionId)),
    loading: useSelector(selectBonusLoading(subscriptionId)),
    error: useSelector(selectBonusError(subscriptionId)),
  }
}
